import { useEffect } from 'react';
import { useUIStore } from '../../store/uiStore';

const TOAST_DURATION = 3000;

const toneColors: Record<string, { bg: string; border: string; text: string }> = {
  success: { bg: '#e6f2ef', border: '#00674F', text: '#004d3b' },
  error: { bg: '#fef2f2', border: '#e51c23', text: '#991b1b' },
  info: { bg: '#f0f4ff', border: '#3b82f6', text: '#1e40af' },
  warning: { bg: '#fdf9e6', border: '#D4AF37', text: '#8a6a1e' },
};

export function Toast() {
  const { toast, hideToast } = useUIStore();

  useEffect(() => {
    if (!toast.isVisible) return;
    const timer = setTimeout(hideToast, TOAST_DURATION);
    return () => clearTimeout(timer);
  }, [toast.isVisible, hideToast]);

  if (!toast.isVisible) return null;

  const colors = toneColors[toast.type] || toneColors.info;

  return (
    <div className="toast-container">
      <div
        className="toast-message"
        style={{
          backgroundColor: colors.bg,
          borderLeft: `4px solid ${colors.border}`,
          color: colors.text,
        }}
        role="alert"
      >
        <span>{toast.message}</span>
        <button
          className="toast-close"
          onClick={hideToast}
          aria-label="Dismiss"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
